<template slot-scope="props">
  <div id="NewGroup">
    <b-container id="SendGroup">
      <b-row id="Top">
        <b-col align-self="center"  xl="2" lg="3" md="3">
          <h3>Create a Group</h3>
        </b-col>
        <b-col align-self="center"  xl="6" lg="6" md="6">
          <b-progress
            id="progress-bar"
            :value="value"
            :max="max"
            class="mb-3"
          ></b-progress>
        </b-col>
      </b-row>
      <form-wizard ref="wizard" id="body-form" title="" subtitle="">
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Create a Group</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/sendSurvey/Group 12567@2x.png"
                  height="194px"
                  width="194px"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content pl-4" cols="8">
              <div class="support_button">
                <router-link
                  id="presentation-button"
                  :to="{ name: route }"
                  :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                  @click.native="goNext()"
                >
                  INVITE PRESENTERS <font-awesome-icon class="icon-button icon-right" icon="angle-right" />
                </router-link>
              </div>
              <b-form-group id="area_name-group" :hidden="!currentUser.admin">
                <div class="input-wrapper">
                  <div>
                    <label for="area_name" class="mb-3"><b>Assign area name</b> (1)<span class="ml-2" >|</span></label>
                     <b-button class="add-org-area-btn ml-3" variant="outline-dark" squared @click="toggleCreateAreaDropdown()">
                        + Create New Area
                      </b-button>
                    <div class="float-right" v-if="createAreaDropdown">
                      <b-form inline>
                        <label for="area_name" class="mr-2 area-name-input-label" >Area name: </label>
                        <b-form-input
                          class="mb-2 mr-sm-2 mb-sm-0 area-name-input"
                          :required="true"
                          id="area_name"
                          name="area_name"
                          v-model="$v.createAreaForm.name.$model"
                        />
                        <b-button class="area-name-input-btn" variant="success" size="sm" @click="createNewArea()">&#x2713;</b-button>
                        <b-button  variant="danger" size="sm" class="ml-2 area-name-input-btn" @click="toggleCreateAreaDropdown()">&#x10102;</b-button>
                      </b-form>
                    </div>
                  </div>
                  <b-form-select
                    id="area_name"
                    name="area_name"
                    v-model="$v.form.area_id.$model"
                    :state="validateState('area_id')"
                    :options="[{ value: '', text: 'Please select an area', disabled: true }, ...existingAreaOptions]"
                  />
                  <b-form-invalid-feedback id="area_name-invalid">
                    This field is required
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
              <b-form-group id="group_name-group">
                <div class="input-wrapper">
                  <label for="group_name"><b>Create group name</b> <span :hidden="!currentUser.admin">(2)</span> <span :hidden="currentUser.admin">(Area: {{groupManagerArea.name}})</span></label>

                  <b-form-input
                    id="group_name"
                    name="group_name"
                    v-model="$v.form.group_name.$model"
                    :state="validateState('group_name')"
                    placeholder="i.e. Sept. 2021 Presentation Training, Construction Conference"
                  />
                  <b-form-invalid-feedback id="group_name-invalid">
                    This field is required
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>
              <b-form-group id="create__error-group">
                <b-form
                  id="create_error-invalid"
                  class="invalid-feedback"
                  style="display: block"
                  v-if="create_error"
                >
                  {{ create_error }}
                </b-form>
              </b-form-group>
              <div class="form_tips" :hidden="!currentUser.admin">
                <p>
                  <b>(1) Assign area name</b>
                  <br>
                  <b>Assign new area:</b> Click on "Create New Area".
                  <br>
                  <b>Select an existing area:</b> Use the drop-down menu.
                </p>
                <p>
                  <b>Examples:</b> Area names might be Finance, Marketing, Training, Human Resources.<br>
                  The group manager you assign will create groups under this area.
                </p>
              </div>
              <div class="form_tips">
                <span>
                   <b><span :hidden="!currentUser.admin">(2)</span> Create group name</b>
                </span>
                <p>
                  <b>Examples:</b> Group names might be Sept 2021 Presentation Training, Interns 2022, Marketing Conferences, VP Feedback.
                </p>
              </div>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Customize Invitation</h3>
              <img
                src="../../../public/img/sendSurvey/Group 12567@2x.png"
                height="194px"
                width="194px"
                class="image-icon"
              />
            </b-col>
            <b-col class="right-content" cols="8">
              <div class="support_button">
                <a
                  id="back-button"
                  class="back-button"
                  v-on:click="goBack()"
                >
                <font-awesome-icon class="icon-button icon-left" icon="angle-left" />
                  BACK
                </a>
                <router-link
                  id="presentation-button"
                  :to="{ name: route }"
                  :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                  @click.native="goNext()"
                >
                  SEND INVITATION <font-awesome-icon class="icon-button icon-right" icon="angle-right" />
                </router-link>
              </div>
              <b-row>
                <b-col>
                  <div id="invitation_message">
                    <h4>Invitation message (You can personalize your message)</h4>
                  </div>
                  <b-form-textarea
                    id="welcome_message"
                    v-model="invitationMessage"
                  >
                  </b-form-textarea>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3 id="share_survey">Invite presenters two ways</h3>
              <img
                src="../../../public/img/sendSurvey/Group 12567_3@2x.png"
                height="194px"
                width="194px"
                class="image-icon"
              />
            </b-col>
            <b-col class="right-content" cols="8">
              <div class="support_button">
                <a
                  class="back-button"
                  v-on:click="goBack()"
                >
                <font-awesome-icon class="icon-button icon-left" icon="angle-left" />
                  BACK
                </a>
                <router-link
                  id="presentation-button"
                  :to="{ name: 'AdminGroups' }"
                  :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                  @click.native="goNext()"
                >
                  GO TO DASHBOARD <font-awesome-icon class="icon-button icon-right" icon="angle-right" />
                </router-link>
              </div>
              <b-row class="send-email-div">
                <div id="email-link">
                  <h3>Send by your personal email</h3>
                  <p>
                    The invitation message will show up in your email
                  </p>
                  <a
                    id="email_button"
                    class="TMGeneralButton router-link-exact-active router-link-active blue"
                    v-bind:href="getMailtoText()"
                    v-on:click="enableGoToDashboardButton()"
                  >
                    EMAIL
                  </a>
                </div>
              </b-row>
              <b-row class="send-link-div">
                <div id="send-link">
                  <h3>Send by Link</h3>
                  <p>
                    You need to create your own invitation message
                  </p>
                  <TMGeneralButton
                    text="COPY LINK"
                    id="link_button"
                    className="blue"
                    @click.native="copyToClipboard()"
                  />
                </div>
              </b-row>
              <b-row class="subscriptionRow">
                <b-form-checkbox v-model="subscription" @change="updateEmailNotification($event)" size="sm">Please email me when a presenter signs up</b-form-checkbox>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
      </form-wizard>
    </b-container>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import TMGeneralButton from "../../components/common/TMGeneralButton.vue";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
import Api from "@/services/api";
import { getAuthorizationToken } from "@/services/utils";

const greaterThanZero = (value) => value > 0;

export default {
  components: { TMGeneralButton },
  name: "NewGroup",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        group_name: "",
        area_id: "",
      },
      createAreaForm: {
        name: "",
        organization_id: ""
      },
      group_code: 0,
      invitationMessage: "",
      emailMe: false,
      active_tab: null,
      value: 33.333333333,
      max: 100,
      overall: true,
      nextButtonAvailable: false,
      previousButtonAvailable: true,
      groupCreated: null,
      route: "",
      create_error: "",
      token: "0",
      localInfo: JSON.parse(localStorage.getItem('currentUser')),
      subscription: true,
      existingAreaOptions: [],
      groupManagerArea: {},
      existingAreaOptions: [],
      createAreaDropdown: false
    };
  },
  validations: {
    form: {
      group_name: {
        required,
      },
      area_id: {
        required,
      },
    },
    createAreaForm: {
      name: { required }
    }
  },

  methods: {
    ...mapActions(["GET_SURVEY_GROUPS_DETAILS"]),

    copyToClipboard(id = null) {
      this.route = "UserDashboard";
      this.nextButtonAvailable = true;
      let fullURL = "";
      if (this.token) {
        id = this.token;

        let path = this.$router.resolve({
          name: "SignUpGroup",
          params: { id: this.token },
        }).href;

        fullURL = window.location.origin + path;
      }
      try {
        navigator.clipboard.writeText(fullURL);
      } catch (e) {
        throw e;
      }
    },
    getMailtoText() {
      var message = encodeURI(this.invitationMessage);
      var subjet = "You have been invited to use TorchMetrics";
      let fullURL = "";
      if (this.token) {
        let path = this.$router.resolve({
          name: "SignUpGroup",
          params: { id: this.token },
        }).href;
        fullURL = window.location.origin + path;
      }
      return `mailto:?subject=${subjet}&body=${message}%0A%0A%0A${fullURL}`;
    },
    validate() {
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data.form, isValid);
      this.nextButtonAvailable = isValid;
      return isValid;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      this.validate();
      return $dirty ? !$error : null;
    },
    goNext() {
      if (this.nextButtonAvailable) {
        if (this.active_tab === null || this.active_tab === 0) {
          this.createGroup();
        } else if (this.active_tab === 1) {
          this.updateInvitationMessage();
        }
      }
    },
    goBack() {
      if (this.active_tab === 2) {
        this.nextButtonAvailable = true;
        this.value = 66.6666666;
        this.$refs.wizard.prevTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      } else if (this.active_tab === 1) {
        this.value = 33.333333333,
        this.$refs.wizard.prevTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      }
    },
    enableGoToDashboardButton() {
      this.route = "AdminGroups";
      this.nextButtonAvailable = true;
    },
    createGroup() {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .post("groups", {
          group: {
            name: this.form.group_name,
            organization_area_id: this.form.area_id,
            group_size: Math.round(this.form.num_presenters),
            organization_id: this.currentUser.organization_id,
            invitation_message: "",
          },
        })
        .then((res) => {
          this.groupCreated = res.data;
          var invitationMessage = res.data.invitation_message;
          var messageReplace01 = invitationMessage.replace("improve.", "improve.\n");
          var messageReplace02 = messageReplace01.replace("you need", "you need\n");
          this.invitationMessage = messageReplace02;
          this.group_code = res.data.code;
          this.nextButtonAvailable = false;
          this.value = 66.666666;
          this.previousButtonAvailable = false;
          this.$refs.wizard.nextTab();
          this.active_tab = this.$refs.wizard.activeTabIndex;
        })
        .catch((err) => {
          this.create_error = err.response.data.organization_max_size[0];
          this.active_tab = 0;
          this.value = 33.333333333;
          this.$refs.wizard.prevTab();
        });
    },
    updateInvitationMessage() {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .patch("groups/" + this.groupCreated.id, {
          group: {
            invitation_message: this.invitationMessage,
          },
        })
        .then((res) => {
          this.generateToken();
          this.previousButtonAvailable = true;
          this.nextButtonAvailable = false;
          this.value = 100;
          this.$refs.wizard.nextTab();
          this.active_tab = this.$refs.wizard.activeTabIndex;
        })
        .catch((err) => {
          this.create_error = err.response.data.organization_max_size[0];
          this.value = 33.333333333;
          this.$refs.wizard.prevTab();
        });
    },
    generateToken() {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .post("groups/generate_invitation_token", {
          group_id: this.groupCreated.id,
        })
        .then((res) => {
          this.token = res.data.token;
        })
        .catch((err) => {
          this.create_error = err.response.data.organization_max_size[0];
          this.value = 66.666666;
          this.$refs.wizard.prevTab();
        });
    },
    updateEmailNotification(event) {
      let body = {
          group: {
            send_email_presenter_joined: this.subscription,
        }
      };
      Api()
        .patch(`groups/${this.groupCreated.id}`, body, {
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          console.log('OK');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createNewArea() {
      Api()
        .post("/organization_areas", { 
            organization_id: this.createAreaForm.organization_id,
            name: this.createAreaForm.name,
         },
         {
          headers: {
            'Authorization': getAuthorizationToken()
          }
        })
        .then(res => {
            this.$toasted.show(`New area "${res.data.name}" successfully created!`);
            this.existingAreaOptions.push({ value: res.data.id, text: res.data.name});
            this.toggleCreateAreaDropdown();
        })
        .catch(err => {
            this.$toasted.show('There was error creating new area.', {type: 'error'});
        });
    },
    toggleCreateAreaDropdown() {
      this.createAreaDropdown = !this.createAreaDropdown;
    }
  },
  computed: {
    ...mapState(["currentUser"]),
    ...mapGetters(["isGroupManager"])
  },
  mounted() {
    this.createAreaForm.organization_id = this.currentUser.organization_id;
    Api().get("organizations/get_organization_areas", {
      params: {
        id: this.currentUser.organization_id
      },
      headers: {
        Authorization: getAuthorizationToken(),
      },
    })
    .then(res => {
      var options = [];
      res.data.forEach(a => options.push({value: a.id, text: a.name}));
      this.existingAreaOptions = options;
    })
    .catch((err) => {
      console.log(err);
    });

    if (this.isGroupManager) {
      Api().get("organizations/find_manager_area", {
        params: {
          group_manager_id: this.currentUser.group_manager_id
        },
        headers: {
          Authorization: getAuthorizationToken(),
        },
      })
      .then(res => {
        this.groupManagerArea = res.data;
        this.form.area_id = res.data.id;
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }
};
</script>
<style lang="less">
@import "../../assets/components/newGroup/newGroup.less";
</style>